import { jsx as _jsx } from "react/jsx-runtime";
import { useRequest } from "@hourly/hooks/useRequest";
import { useState } from "react";
import { RoleActionsContext } from "./RoleActionsContext";
export const RoleActionsProvider = ({ api, children }) => {
    const [roleActions, setRoleActions] = useState({});
    const { status } = useRequest(async () => {
        const { data } = await api.get("/v1/permissions");
        setRoleActions(data);
    }, { requestOnMount: true });
    if (status.isLoading || !Object.entries(roleActions).length) {
        return null;
    }
    return (_jsx(RoleActionsContext.Provider, { value: roleActions, children: children }));
};
